import { getBaseUrl, request } from 'src/helper/api';

export const authForgotPassword = () =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/public/forgot-password`,
      contentType: 'json',
    },
    'auth/forgotPassword',
  );

export const authCheckSignedUrl = (verifyId?: string, expires?: number, signature?: string) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/public/verify/${verifyId}?expires=${expires}&signature=${signature}`,
    },
    'auth/checkSignedUrl',
  );

export const authResetPassword = () =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/public/reset-password`,
      contentType: 'json',
    },
    'auth/resetPassword',
  );
